import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import RouteManager from '../../managers/RouteManager';
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from '../../managers/TableManger';
import { fetchBenefitsByPage, selectBenefitsByPage } from '../../Redux/Slices/BenefitSlice';
import BenefitService from '../../services/BenefitService';
import { showToast, TOAST_TYPE } from 'deskera-ui-library';
import Utility, { deepClone, removeDelayedLoader, showDelayedLoader } from '../../utility/Utility';
import { BenefitsColumnConfig, parseColumnConfig } from '../configs/config';
import DataGridHolderPayroll from '../common/DataGridHolderPayroll';
import Table from '../../services/table';
import AddEditBenefitsPopup from './AddEditBenefitsPopup';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';

const BenefitsList = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: {},
        filter: {}
    };

    const dispatch = useDispatch();
    const benefitsList = useSelector(selectBenefitsByPage)
    const isActionEnabled = true


    const [benefitListState, setBenefitListState] = useState(initialState);
    const [refresh, setRefresh] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [showList, setFiltersList] = useState(true);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [showAddBenefits, setShowAddBenefits] = useState(false);
    const [selectedBenefit, setSelectedBenefit] = useState({});
    const [reload, setReload] = useState(false);

    useEffect(() => {
        RouteManager.setPresenter({ props });
        loadBenefitsList({})
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(benefitsList)) {
            const { benefits, filterResponse } = benefitsList;
            const rowData = BenefitsColumnConfig(benefits);
            let benefitFieldColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.BENEFIT_LIST))
            const passingData = {
                columnData: deepClone(benefitFieldColumn),
                rowData,
                filter: [],
                originalData: benefits
            };
            const isFilterListEnabled = benefitsList.length > 0 ? true : false;
            setBenefitListState(passingData);
            setTotalPageCount(filterResponse.totalPages);
            setCurrentPage(+filterResponse?.currentPage);
            setTotalCount(filterResponse.totalCount)
            setFiltersList(isFilterListEnabled);
            setFilterInitialValue(0);
        }    
    }, [benefitsList, reload])

    const loadBenefitsList = async (config) => {
        try {
            if(!Utility.isEmpty(config)){
                BenefitService.apiConfig = config;
            }
            const timeout = showDelayedLoader();
            await dispatch(fetchBenefitsByPage());
            removeDelayedLoader(timeout);
        } catch (err) {
            console.error('Error loading benefits: ', err);
        }
    }

    const onDeleteBenefits = (data) => {
        let benefitId = []
        let params = {}
        if(data && data.rowData) {
            benefitId = [data.rowData.id]
            params = {
                'benefitIds': benefitId
            }
        } else if(data.length>0){
            data.forEach(benefit => {
                benefitId.push(benefit.id)
             })
             params = {
                'benefitIds': benefitId
            }
         }
        (Table.deleteBenefits(params)
        ).then(
                (res) => {
                    showToast(
                        `Benefit deleted.`,
                        TOAST_TYPE.SUCCESS
                    );
                    loadBenefitsList({})
                },
                (err) => {
                    showToast(
                        "Some Unknown Error Occurred at Server.Please Try Again!",
                        TOAST_TYPE.FAILURE
                    );
                }
            );

    }

    const onClose = () => {
        setShowAddBenefits(false)
        setSelectedBenefit({})
    }

    const onRowEdit = (data) => {
        let selected = benefitsList.benefits.find(e => e.benefitId === data.rowData.id)
        setSelectedBenefit(selected)
        setShowAddBenefits(true)

    }
    const updateBenefit=(benefit)=>{
        Table.updateBenefit(benefit).then((data) => {
            showToast("Status updated Successfully", TOAST_TYPE.SUCCESS);
            loadBenefitsList({})
        })
    }
    const onRowUpdate = (data) => {
        if(data['columnKey'] == 'status') {
            let rowData = (data['rowData']);
            let isActive = (rowData.data.isActive ||( rowData.data.isActive == false))? rowData.data.isActive.toString():'false';
            let selected = rowData.status.length!=0 ? rowData.status[0]:'';
            let benefit = Object.assign({},rowData.data);
            if(rowData.data && ( isActive != selected)) {
                benefit['isActive'] = (selected=='ACTIVE') ? true:false;
                updateBenefit(benefit);
            } else if(rowData.status.length == 0) {
                updateBenefit(benefit);
            }
        }
    }

    const onContextCancel = () => {
      setReload(!reload)
    }

    return (
        <div className="column parent-width flex-1 parent-height">
            <div className="column parent-width mb-s position-relative flex-1 ">

                <DataGridHolderPayroll
                    tableName={TABLES.BENEFIT_LIST}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.BENEFIT_LIST]}
                    allowRowEdit={PermissionUtils.hasAccess(MODULE.BENEFITS,[ACTION.EDIT])}
                    allowColumnEdit={false}
                    allowRowAdd={true}
                    allowColumnAdd={false}
                    allowColumnDelete={true}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    onRowDelete={onDeleteBenefits}
                    onRowEdit={(data) => {
                        onRowEdit(data);
                    }}
                    onCancelContext={() => {
                      onContextCancel();
                    }}
                    //   onProcessPayroll={processPayroll}
                    refresh={refresh}
                    addButtonConfig={[{
                        title: "+ Add Benefit",
                        className: "bg-app text-white",
                        onClick: () => {setShowAddBenefits(true)},
                    }]}
                    allowDataExport={true}
                    gridData={benefitListState}
                    //   onSearch={onSearch}
                    //   onColumnAdd={newColumnAdded}
                    //   onFilter={onFilter}
                    filter={benefitsList.filterResponse}
                    //   onRowAdd={onRowAdd}
                    onPaginationClick={(requestedPageNumber) => {
                        const config = {
                            ...BenefitService.apiConfig,
                            currentPage: requestedPageNumber, // Books backend pagination offset is 0, so subtract 1
                        };
                        loadBenefitsList(config);
                    }}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    isActionEnabled={true}
                    isMenuVisible={true}
                    contextMenu={true}
                    showContextEdit = {false}
                    isHideTooltip={true}
                    onRowUpdate={onRowUpdate}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.BENEFITS}
                />
                {showAddBenefits && (
                    <div className="transparent-background">
                        <AddEditBenefitsPopup
                            onClose={() => onClose()}
                            data = {selectedBenefit}
                            loadBenefit = {() => loadBenefitsList()}
                            // loadCustomFields={() => loadCustomFields()}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default BenefitsList
